import { PaymentMethod } from '@ca/common'
import { DiscountOption } from '@order/orderTypes'
import { useTotalDiscountAmount } from '@order/useDiscounts'
import getDiscountedTotals from '@order/utils/getDiscountedTotals'
import { useCallback } from 'react'
import useOrderTotal from './useOrderTotal'

export const usePaymentValues = ({
  orderTotal,
  discounts,
}: {
  orderTotal: ReturnType<typeof useOrderTotal>
  discounts: DiscountOption[]
}) => {
  const discountAmount = useTotalDiscountAmount({ orderTotal, discounts })
  return useCallback(
    (method: PaymentMethod) => {
      const { isNet } = getDiscountedTotals(orderTotal, discountAmount.custom)
      const discount = isNet ? 0 : Math.abs(discountAmount.custom || 0)
      const toPay =
        method === 'monthly'
          ? discountAmount.discountedMonthly
          : discountAmount.discounted
      return {
        total: orderTotal.resolved,
        discount,
        discounted: discountAmount.discounted,
        toPay,
      }
    },
    [orderTotal, discountAmount]
  )
}
